import Swiper from 'swiper';

document
  .querySelectorAll('.section-gallery-slider-grid')
  .forEach((section) => {
    // Get thumb slider and gallery slider within this section
    const thumbSliderEl = section.querySelector('.thumb-slider');
    const gallerySliderEl = section.querySelector('.gallery-slider');

    // Check if both sliders are present in this section
    if (thumbSliderEl && gallerySliderEl) {
      // Initialize the thumbnail slider
      const thumbSlider = new Swiper(thumbSliderEl, {
        watchSlidesProgress: true,
        breakpoints: {
          0: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 6,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 6.3,
            spaceBetween: 24,
          },
        },
      });

      // Initialize the main gallery slider and link it to the thumbnail slider
      new Swiper(gallerySliderEl, {
        loop: true,
        spaceBetween: 24,
        navigation: {
          nextEl: section.querySelector('.gallery-slider-next'),
          prevEl: section.querySelector('.gallery-slider-prev'),
        },
        thumbs: {
          swiper: thumbSlider,
        },
      });
    }
  });
